/** CRA `PUBLIC_URL` is often ""; if unset, avoid the string "undefined" in URLs. */
export function publicAssetUrl(relativePath) {
  const rel = String(relativePath || '').replace(/^\//, '');
  const prefix = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return prefix ? `${prefix}/${rel}` : `/${rel}`;
}
